import { raygun } from '@ynap/clientside-monitoring'

const buyapowaTracking = {
    track: (marketDomain: string, market: string, orderRef: string, promotionCode: string): void => {
        import(/* webpackChunkName: "buyapowasdk" */ './buyapowa-sdk')
            .then(() => {
                const buyapowa = new window.Buyapowa({
                    url: `https://${marketDomain}`,
                    market,
                })
                buyapowa.track({
                    order_number: orderRef,
                    voucher_code: promotionCode,
                })
            })
            .catch((error) => {
                raygun.helpers.agent('send', {
                    error,
                    tags: ['checkout', 'buyapowa-sdk'],
                    customData: {
                        marketDomain,
                        market,
                        orderId: orderRef,
                        promotionCode,
                    },
                })
            })
    },
}

export function isBuyapowaCode(code) {
    const regex = /^(RAF|WELCOME)\w+/

    if (!code) {
        return false
    }

    return regex.test(code)
}

export default buyapowaTracking
